import type { Path, SetValueConfig, UseFormSetValue } from 'react-hook-form';

import type { NewTicketFormValuesT } from '../declarations';

/**
 * Clears optional creation attachment fields for the single-ticket form (`rowIdSuffix` null)
 * or for one row in bulk create (`rowIdSuffix` = that row’s id).
 */
export function clearCreationAttachmentFormFields(
  setValue: UseFormSetValue<NewTicketFormValuesT>,
  rowIdSuffix: string | null,
  setOptions?: SetValueConfig
): void {
  const sfx = rowIdSuffix == null ? '' : `-${rowIdSuffix}`;
  setValue(`creationAttachmentNote${sfx}` as Path<NewTicketFormValuesT>, '', setOptions);
  setValue(`creationAttachmentTypeCode${sfx}` as Path<NewTicketFormValuesT>, '', setOptions);
  setValue(`creationAttachmentFile${sfx}` as Path<NewTicketFormValuesT>, undefined, setOptions);
  setValue(`creationAttachmentPhoto${sfx}` as Path<NewTicketFormValuesT>, undefined, setOptions);
}

/** Clears shared creation attachment fields (one RO-level block for bulk create). */
export function clearAllBulkCreationAttachmentFormFields(
  setValue: UseFormSetValue<NewTicketFormValuesT>,
  _rowIds: readonly string[],
  setOptions?: SetValueConfig
): void {
  clearCreationAttachmentFormFields(setValue, null, setOptions);
}
